module.exports = __webpack_public_path__ + "static/5af92072.tmallTopLogo.png";